export class StateIndicatorService {

    static $inject = [ "$rootScope", "catalogsService", "$injector", "gameSceneService", "gettextCatalog" ];

    constructor( $rootScope, catalogsService, $injector, gameSceneService, gettextCatalog ) {

        this.catalogsService = catalogsService;
        this.$injector = $injector;
		this.gameSceneService = gameSceneService;
        this.gettextCatalog = gettextCatalog;

		$rootScope.stateIndicator = this;
    }

    set( message = null, scope = null, state = null ) {
        this.setHtml( message, scope, state );
    }

    async setCatalogItem( catalog_item, catalog ) {

        let { gettextCatalog } = this;

        if (!catalog_item) {
            this.clear();
            return;
        }

        await this.catalogsService.getClientOeuvreItemAsync( catalog_item, catalog );

        let prev_item = catalog.getPrevItemOf( catalog_item );
        let next_item = catalog.getNextItemOf( catalog_item );

        let heading = this.catalogsService.getItemHeading( catalog_item );

        
        if (heading) {

            let html = heading;
            let scope = {
				catalog_item,
                prev_item,
                next_item,
                goToItem: item => {
                    this.$injector.get( "$playerHandler" ).doGoToCatalogItem( item, catalog );
				},
				openItemViewer: () => {
					this.catalogsService.openCatalogItemViewer( catalog_item, catalog, this.gameSceneService.arrangement );
				}
            };

			if (this.gameSceneService.arrangement) {

				html = `<button class="btn btn-lg btn-link" ng-click="openItemViewer()" style="color:#000">${ html }</button>`;

			} else {

				html = `&nbsp;${ html }&nbsp;`;
			}

            if (prev_item) {
                /* await this.catalogsService.getClientOeuvreItemAsync( prev_item, catalog );
                let prev_heading = this.catalogsService.getItemHeading( prev_item ); */

                if (prev_item) html = `<button ng-click="goToItem( prev_item )" class="btn btn-link" style="color:#000">
                    <b class="glyphicon glyphicon-chevron-left"></b>
                    <span>${ gettextCatalog.getString( "Previous catalog item" ) }</span>
                </button>${ html }`;
            }

            if (next_item) {
                /* await this.catalogsService.getClientOeuvreItemAsync( next_item, catalog );
                let next_heading = this.catalogsService.getItemHeading( next_item ); */

                if (next_item) html = `${ html }<button ng-click="goToItem( next_item )" class="btn btn-link" style="color:#000">
                    <span>${ gettextCatalog.getString( "Next catalog item" ) }</span>
                    <b class="glyphicon glyphicon-chevron-right"></b>
                </button>`;
            }

            this.setHtml( html, scope, "info" );
        }
    }
}
